"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const equationTypePredicates_1 = require("./equationTypePredicates");
exports.walkUntil = (pred, equation) => {
    if (!equation) {
        return false;
    }
    const { left, operator, right } = equation;
    if (pred(left) || pred(operator) || pred(right)) {
        return true;
    }
    let result = false;
    if (equationTypePredicates_1.isEquation(left)) {
        result = exports.walkUntil(pred, left);
    }
    if (equationTypePredicates_1.isEquation(right)) {
        result = result || exports.walkUntil(pred, right);
    }
    return result;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2Fsa1VudGlsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2V2YWx1YXRvci9lcXVhdGlvbi93YWxrVW50aWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQSxxRUFBc0Q7QUFFekMsUUFBQSxTQUFTLEdBQUcsQ0FDdkIsSUFBNEMsRUFDNUMsUUFBa0IsRUFDVCxFQUFFO0lBQ1gsSUFBSSxDQUFDLFFBQVEsRUFBRTtRQUNiLE9BQU8sS0FBSyxDQUFDO0tBQ2Q7SUFDRCxNQUFNLEVBQUUsSUFBSSxFQUFFLFFBQVEsRUFBRSxLQUFLLEVBQUUsR0FBRyxRQUFRLENBQUM7SUFDM0MsSUFBSSxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksSUFBSSxDQUFDLFFBQVEsQ0FBQyxJQUFJLElBQUksQ0FBQyxLQUFLLENBQUMsRUFBRTtRQUMvQyxPQUFPLElBQUksQ0FBQztLQUNiO0lBQ0QsSUFBSSxNQUFNLEdBQUcsS0FBSyxDQUFDO0lBQ25CLElBQUksbUNBQVUsQ0FBQyxJQUFJLENBQUMsRUFBRTtRQUNwQixNQUFNLEdBQUcsaUJBQVMsQ0FBQyxJQUFJLEVBQUUsSUFBSSxDQUFDLENBQUM7S0FDaEM7SUFDRCxJQUFJLG1DQUFVLENBQUMsS0FBSyxDQUFDLEVBQUU7UUFDckIsTUFBTSxHQUFHLE1BQU0sSUFBSSxpQkFBUyxDQUFDLElBQUksRUFBRSxLQUFLLENBQUMsQ0FBQztLQUMzQztJQUNELE9BQU8sTUFBTSxDQUFDO0FBQ2hCLENBQUMsQ0FBQyJ9